<template>
  <div class="organized_container">
    <div
      :class="{
        container_bg: true,
        container_green: curBG === 'typeGreen' ? true : false,
      }"
    >
      <img :src="getContainerBG" v-if="backgroundMask"/>
    </div>
    <div class="overal_bg" v-if="curBG == 'typeDark'"></div>
    <div class="overal_bg_strong" v-if="curBGVal == 'typeStrong'"></div>
    <left-part
      :modelType="modelType"
      ref="leftPart"
      v-if="!isSetting && refreshTag"
    ></left-part>
    <right-part :modelType="modelType" v-if="!isSetting && refreshTag && customerId != 65"></right-part>
    <setting :modelType="modelType" v-if="isSetting"></setting>
    <!-- <bulletChat v-if="refreshTag" /> -->
    <!-- <pupButton v-if="refreshTag" :pupType="'1'" /> -->
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import leftPart from "@/modules/DIYcomponents/leftPart.vue";
import rightPart from "@/modules/DIYcomponents/rightPart.vue";
import setting from "@/modules/DIYcomponents/setting.vue";
import { mapState } from "vuex";
import bulletChat from "@/modules/organizedComponents/bulletChat/bulletChat.vue";
// import pupButton from "@/modules/popupComponents/pupButton/pupButton.vue";

import { unorganizedLightWallRender } from "@/assets/js/lightWall/unorganized_science.js";
import { dutyLightWallRender } from "@/assets/js/lightWall/duty_science.js";

import { CamLeapFunc } from "@/assets/js/unity3D/index.js";
import {dateFormat} from "utils/tools";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { leftPart, rightPart, setting, bulletChat },
  props: {},
  data() {
    //这里存放数据
    return {
     pageInfo: 'OrganizedMod.vue',
     computedName: '有组织首页组件',
     backgroundMask: bmeConfig.backgroundMask,
     customerId: this.$store.state.customerId,
      isSetting: false,
      hash: false,
      modelType: "OrganizedMod",
      styleType: bmeConfig.styleType,
      styleTypeMap: styleTypeMap,
      curBG: "",
      refreshTag: true,
    };
  },
  errorCaptured(error,vm,info) {
    console.log('kk-',error,vm,info);
    let msg = '错误信息：' + error + '，错误详情：' + info;
    let computedName = vm.mtitle || vm.computedName;
    return false;
    // this.requestExceptCap(msg,instance);
  },
  //计算属性 类似于data概念
  computed: {
    getContainerBG: function () {
      let imgSrc = "";
      if (
        this.curBG &&
        this.styleTypeMap[this.curBG] &&
        this.styleTypeMap[this.curBG].dutyBG
      ) {
        imgSrc = require("@/views/MainMod/img/" + this.styleTypeMap[this.curBG].dutyBG);
      }
      if(!bmeConfig.backgroundMask){
       imgSrc = ''
      }
      return imgSrc;
    },
    curBGVal: function () {
      return this.$store.state.curBG;
    },
  },
  //监控data中的数据变化
  watch: {
    hash: {
      handler(newVal, oldVal) {
        this.isSetting = newVal;
      },
      deep: true,
    },
    curBGVal: {
      handler(newVal, oldVal) {
        this.curBG = newVal;
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (this.$route.hash.substr(1) == "setting") {
      this.hash = true;
    } else {
      this.hash = false;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.curBG = this.$store.state.curBG;
  },
  //方法集合
  methods: {
    /**
     * @Description: 全局异常捕获上传
     * @param {String} msg 报错信息
     * @param {Object} instance 报错组件
     * @return void
     * @author liqiuyu
     * @date 2024/3/12
     */
    requestExceptCap(msg, instance) {
      const date = new Date();
      const time = dateFormat('YYYY-mm-dd HH:MM:SS',date);
      const url = this.$apiOpt.platformCollect;

      const param = {
        firstLevelCode: 'notOpen',
        secondLevelCode: 'beforeError',
        additionalInfo: {
          source: 'screen',
          mac: '867788sjgdjbsd',
          customerId: window.bmeConfig.customerSign,
          sourceFile: instance.computedName,
          sourcePage: instance.pageInfo,
          time: time,
          msg: msg
        }
      }
      this.$apiUtils.post(url,param).then(res => {

      }).catch(error => {

      });
    },
    reset() {
      this.modelType = "OrganizedMod";
      this.refreshTag = true;
    },
    reload() {
      this.refreshTag = false;
      this.$nextTick(function () {
        this.reset();
        this.refreshTag = true;
      });
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.setting == "true") {
      this.hash = true;
    } else {
      this.hash = false;
    }
    //console.log(2222);
    this.reload();
  },
  beforeRouteEnter(to, from) {
    // dutyLightWallRender(true, "update");
    unorganizedLightWallRender(false);
    CamLeapFunc();
  },
};
</script>
<style scoped>
.organized_container {
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
}

.container_bg {
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  z-index: -1;
}

.container_bg > img {
  filter: opacity(100%) grayscale(15%) blur(1px) contrast(95%) saturate(95%);
  width: 102%;
  height: 100%;
}

.container_green {
  filter: opacity(70%) grayscale(15%) blur(1px) contrast(95%) saturate(95%) !important;
}

.overal_bg {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
.overal_bg_strong {
  position: absolute;
  left: 15px;
  top: 120px;
  bottom: 15px;
  right: 15px;
  background-image: url("/static/images/common/overal.png");
  background-size: 100% 100%;
  background-repeat: "no-repeat";
  z-index: -1;
}
</style>
